// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2806":"4c365959f73103c8a5c1","5308":"9371d3f5d0da4fbb84f3","7237":"4c365959f73103c8a5c1"}[chunkId] + ".css";
};